module.exports = __webpack_public_path__ + "static/media/slide-3.39351b7c.jpg";